<template>
  <div class="custom-tree-container">
    <div class="add-page" v-if="TableData.join('') === ''">
      <el-button
        size="mini"
        type="primary"
        @click="methodAddMenu"
        icon="el-icon-plus"
        >新增导航</el-button
      >
    </div>
    <div class="tree">
      <el-tree
        :data="TableData"
        show-checkbox
        highlight-current
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        :indent="40"
      >
        <template #default="{ node,data }">
          <div
            :class="{
              'custom-tree-node': true,
              'has-children': data.children,
              'has-dashed': data.type === 2,
            }"
          >
            <div class="tree-node-left">
              <span class="node-name">{{ data.resource.name }}</span>
              <div class="btn-viewscope" v-if="data.resource.viewScopes">
                <el-radio-group v-model="data.resource.viewScopes">
                  <el-radio
                    disabled
                    v-for="scopeItem in viewScopeOptions.filter((item) =>
                      data.resource.viewScopes.includes(item.value)
                    )"
                    :key="scopeItem.value"
                    :label="scopeItem.value"
                    >{{ scopeItem.label }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <span>
              <el-button
                v-if="data.resource.type !== 'BUTTON'"
                type="text"
                size="mini"
                @click="methodAppend(data)"
              >
                + 新增
              </el-button>

              <el-button
                type="text"
                size="mini"
                @click="() => methodEdit(data)"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                size="mini"
                @click="() => methodRemove(data)"
              >
                删除
              </el-button>
            </span>
          </div>
        </template>
      </el-tree>
    </div>

    <el-dialog
      :title="dialogInfo.title"
      :visible.sync="dialogInfo.show"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <wgTabs
          :tabData="tabs"
          @tabChange="getActive"
          v-if="dialogInfo.show && dialogInfo.type === 'all'"
        ></wgTabs>
        <el-form
          ref="form"
          :model="formParams"
          size="mini"
          label-position="left"
        >
          <el-form-item label="排序号">
            <el-input-number
              v-model="formParams.sort"
              :precision="1"
              :step="0.1"
              :max="100"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="资源名称">
            <el-input v-model="formParams.name"></el-input>
          </el-form-item>
          <el-form-item label="资源Key">
            <el-input v-model="formParams.alias"></el-input>
          </el-form-item>
          <!-- 不是 MENU 的时候显示 -->
          <template v-if="tabs.active !== 'MENU'">
            <el-form-item label="资源路径">
              <el-input v-model="formParams.path"></el-input>
            </el-form-item>
          </template>
          <!-- 不是 BUTTON 的时候显示 -->
          <template v-if="tabs.active === 'MENU'">
            <el-form-item label="图标">
              <el-input v-model="formParams.iconUrl"></el-input>
            </el-form-item>
          </template>
          <!-- 否则显示 -->
          <template v-if="tabs.active === 'BUTTON'">
            <el-form-item label="默认勾选">
              <el-radio-group v-model="formParams.defaultFlag">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="不可取消标识">
              <el-radio-group v-model="formParams.notCanceled">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="数据展示">
              <el-cascader
                v-model="formParams.viewScopes"
                :options="viewScopeOptions"
                :props="{ multiple: true, checkStrictly: true }"
                clearable
                @change="methodViewScopes"
              ></el-cascader>
            </el-form-item>
          </template>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogInfo.show = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="methodConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// API
import {
  api_queryResourceTree,
  api_createResourceTree,
  api_editResourceTree,
  api_deleteResourceTree,
} from '@/api/javaApi'
// Component
import wgTabs from '@/components/wgTabs'
// utils
import { removeMatchingProperties } from '@/utils/utils'

export default {
  components: {
    wgTabs,
  },
  data() {
    return {
      TableData: [],
      tabs: {
        active: 'MENU',
        list: [
          { label: '菜单', index: 'MENU' },
          { label: '页面', index: 'PAGE' },
          { label: '按钮', index: 'BUTTON' },
        ],
      },
      dialogInfo: {
        flag: 'add',
        show: false,
        title: '新增节点',
        type: 'menu', // menu | all
      },
      dataItem: null,
      formParams: {
        sort: '',
        name: '',
        alias: '',
        iconUrl: '',
        path: '',
        level: '',
        parentId: '',
        defaultFlag: true,
        notCanceled: true,
        viewScopes: [],
      },
      viewScopeOptions: [
        { label: '全部数据', value: 'DEFAULT' },
        { label: '个人数据', value: 'PERSONAL' },
      ],
    }
  },
  mounted() {
    this.queryResourceTree()
  },
  watch: {
    'dialogInfo.show': {
      handler(val) {
        if (!val) {
          // Object.assign(this.$data, this.$options.data())
          this.formParams = this.$options.data().formParams
        }
      },
    },
  },
  // computed: {
  //   viewScopes,
  // },
  methods: {
    methodViewScopes(val) {
      console.log(val)
      // this.viewScopes = val.flat(Infinity)
    },
    getActive(active) {
      console.log(active)
      this.tabs.active = active
      this.formParams.type = active
    },
    //查询列表
    queryResourceTree() {
      api_queryResourceTree().then((res) => {
        if (res) {
          this.TableData = this.recursiveSortTree([res])
        } else {
          this.TableData = []
        }
      })
    },
    // 递归排序
    recursiveSortTree(list) {
      if (list.length > 0) {
        list.sort((first, last) => {
          return first.resource.sort - last.resource.sort
        })
        list.forEach((child) => {
          if (child.children) {
            this.recursiveSortTree(child.children)
          }
        })
      }
      return list
    },
    // 添加
    createResourceTree(params) {
      api_createResourceTree(params).then((res) => {
        console.log('添加结果：', res)
        this.queryResourceTree()
      })
    },
    // 编辑
    editResourceTree(params) {
      api_editResourceTree(params).then((res) => {
        console.log('编辑结果：', res)
        this.queryResourceTree()
      })
    },
    // 点击新增按钮
    methodAddMenu() {
      this.dialogInfo = {
        flag: 'add',
        show: true,
        title: '新增菜单',
        type: 'menu',
      }
      this.tabs.active = 'MENU'
    },
    methodAppend(data) {
      this.dataItem = data
      this.dialogInfo = {
        flag: 'add',
        show: true,
        title: '新增',
        type: 'all',
      }
      this.tabs.active = 'MENU'
    },
    // 添加接口参数处理
    interfaceParamsHandleAdd() {
      if (this.dialogInfo.type === 'menu') {
        return {
          sort: this.formParams.sort,
          name: this.formParams.name,
          alias: this.formParams.alias,
          type: 'MENU',
          level: 1,
        }
      } else if (this.dialogInfo.type === 'all') {
        return {
          sort: this.formParams.sort,
          name: this.formParams.name,
          alias: this.formParams.alias,
          type: this.tabs.active,
          iconUrl: this.formParams.iconUrl,
          path: this.formParams.path,
          level: this.dataItem.resource.level + 1,
          parentId: this.dataItem.resource.id,
          defaultFlag: this.formParams.defaultFlag,
          notCanceled: this.formParams.notCanceled,
          viewScopes: this.formParams.viewScopes.join(','),
        }
      }
    },
    // 编辑接口参数处理
    interfaceParamsHandleEdit() {
      if (
        this.formParams.viewScopes &&
        Object.prototype.toString.call(this.formParams.viewScopes) ===
          '[object Array]'
      ) {
        this.formParams.viewScopes = this.formParams.viewScopes.join(',')
      }
      const newFormParams = removeMatchingProperties(
        this.formParams,
        this.dataItem.resource,
        ['id', 'parentId']
      )
      return newFormParams
    },
    // 确认操作
    methodConfirm() {
      let params = null
      switch (this.dialogInfo.flag) {
        case 'add':
          params = this.interfaceParamsHandleAdd()
          this.createResourceTree(params)
          break
        case 'edit':
          params = this.interfaceParamsHandleEdit()
          this.editResourceTree(params)
          break
        default:
          console.error('确认操作程序错误')
          break
      }
      this.dialogInfo.show = false
    },
    // 编辑
    methodEdit(data) {
      console.log(data)
      this.dataItem = data
      this.tabs.active = data.resource.type
      this.formParams = {
        ...data.resource,
      }
      if (this.formParams.viewScopes) {
        this.formParams.viewScopes = this.formParams.viewScopes.split(',')
      }
      this.dialogInfo = {
        flag: 'edit',
        show: true,
        title: '编辑',
        type: 'all',
      }
    },
    methodRemove(data) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api_deleteResourceTree({
          id: data.resource.id,
        }).then((res) => {
          console.log(res)
          // if (res.is_delete) {
          this.$message.success('删除成功')
          this.queryResourceTree()
          // }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.custom-tree-container {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  background: #fff;
  padding: 20px;
  border-radius: 5px;

  .add-page {
  }
  .tree {
    padding: 20px;
    .el-tree /deep/ {
      color: #333;
      & > .el-tree-node {
        margin-bottom: 15px;
        // &.is-expanded {
        //   &::before {
        //     content: '';
        //     position: absolute;
        //     left: 30px;
        //     top: 10px;
        //     z-index: 1;
        //     height: 100%;
        //     border-left: 1px dashed #419eff;
        //   }
        // }
        & > .el-tree-node__children {
          & > .el-tree-node {
            margin-bottom: 15px;
            &.is-expanded {
              &::before {
                content: '';
                position: absolute;
                left: 70px;
                top: 10px;
                z-index: 1;
                height: 100%;
                border-left: 1px dashed #419eff;
              }
            }
          }
        }
      }
      .el-tree-node {
        position: relative;
        z-index: 1;
        .el-tree-node__content {
          .el-tree-node__expand-icon:not(.is-leaf) {
            color: #419eff;
          }
        }
        // 子集
        .el-tree-node__children {
          .el-tree-node {
            .el-tree-node__content {
              // padding-left: 40px !important;
              // .expanded {
              //   position: absolute;
              //   left: 0px;
              //   &::before {
              //     content: '';
              //     display: inline-block;
              //     width: 1px;
              //     height: 13px;
              //     background-color: #419eff;
              //   }
              //   &::before {
              //     content: '';
              //     display: inline-block;
              //     width: 13px;
              //     height: 1px;
              //     background-color: #419eff;
              //   }
              // }
              .has-dashed {
                position: relative;
                z-index: 1;
                &::before {
                  content: '';
                  position: absolute;
                  left: -55px;
                  top: 14px;
                  z-index: 1;
                  width: 15px;
                  border-top: 1px dashed #419eff;
                }
                // &::after {
                //   content: '丅';
                //   position: absolute;
                //   left: -55px;
                //   top: 14px;
                //   z-index: 1;
                //   width: 15px;
                //   border-top: 1px dashed #419eff;
                // }
              }
            }
          }
        }
      }
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 20px;
      .tree-node-left {
        display: flex;
        .node-name {
          width: 180px;
        }
        .btn-viewscope {
          .el-radio-group {
            .el-radio.is-disabled /deep/ {
              .el-radio__input.is-disabled + span.el-radio__label {
                color: #666;
              }
            }
          }
        }
      }
    }
  }
  .dialog-content {
    .wg-tabs {
      margin-bottom: 15px;
    }
    .el-form {
      padding: 0 20px;
    }
  }
}
</style>
